//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      // list:[{title: '适用人群',cont:'适用于18-60周岁的人群'}]
    }
  },
  props: {
    title: {
      type: String,
      required:true
    },
    cont:{
      type: String,
    },
    link:{
      type: Boolean,
      default:false
    }
  },
  methods:{
    liClick(item){
      if(this.link){
        this.$emit('liClick',item)
      }
    }
  }
}
